import { Accordion, Box, Text } from "@mantine/core";
import useStyles from "./styles";
import { IconInfoCircle, IconChevronDown } from "@tabler/icons-react";

const EssentialViewInfo = ({ data, className }) => {
  const { classes } = useStyles();

  if (!data) return null;

  const isActivityLevelData =
    Array.isArray(data?.activities) && data.activities.length > 0;

  const selectedActivity = isActivityLevelData
    ? data.activities.find((a) => a.id === data.essentialActivityNumber)
    : null;

  const howOftenValue = selectedActivity && selectedActivity?.howOftenEssentialSupport
    ? selectedActivity.howOftenEssentialSupport
    : data?.howOftenEssentialSupport;

  const activityList = isActivityLevelData
    ? data.activities.filter((a) => a.id === data.essentialActivityNumber)
    : [];

  return (
    <Accordion
      variant="separated"
      radius="lg"
      className={`${classes.cpinfo} ${className ? className : ""}`}
      chevron={<IconChevronDown size={18} className={classes.cpinfoChevron} />}
      chevronPosition="right"
    >
      <Accordion.Item key={1} value={"Medication Detail"}>
        <Accordion.Control className={classes.cpinfoHead}>
          <Box className={classes.cpinfoHeadRow}>
            <Box className={classes.cpinfoBadge}>
              <IconInfoCircle size={16} />
            </Box>
            <Box className={classes.cpinfoHtext}>
              <Text className={classes.cpinfoEyebrow}>Care plan reference</Text>
              <Text className={classes.cpinfoTitle}>Essential Support Activities</Text>
            </Box>
          </Box>
        </Accordion.Control>
        <Accordion.Panel>
          <Box  className={classes.cpinfoBody}>
            {activityList.map((a, index) => (
              <Box key={a.id || index} className={classes.cpinfoGrid}>
                <Box className={classes.cpinfoGridLeft}>
                  <Text className={classes.cpinfoLbl}>
                    {index + 1}. Support Statement
                  </Text>
                  <Text className={classes.cpinfoVal}>
                    {a?.supportStatement || "-"}
                  </Text>
                </Box>
                <Box className={classes.cpinfoGridRight}>
                  <Text className={classes.cpinfoLbl}>How to Support</Text>
                  {Array.isArray(a?.howToSupport) ? (
                    a?.howToSupport?.length > 0 ? (
                      a.howToSupport.map((h, i) => (
                        <Text key={h.id || i} className={classes.cpinfoVal}>
                          {h?.text || "-"}
                        </Text>
                      ))
                    ) : (
                      <Text className={classes.cpinfoVal}>-</Text>
                    )
                  ) : (
                    <Text className={classes.cpinfoVal}>
                      {a?.howToSupport || "-"}
                    </Text>
                  )}
                </Box>
              </Box>
            ))}

            <Box className={classes.cpinfoFoot}>
              <Text
                className={`${classes.cpinfoLbl} ${classes.cpinfoFootLbl}`}
              >
                How Often
              </Text>
              <Box className={classes.cpinfoPill}>{howOftenValue || "-"}</Box>
            </Box>
          </Box>
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};

export default EssentialViewInfo;
